export default {
  id: 'cash-registers',
  title: 'Blagajne',
  icon: 'mdi-cash-register',
  show: true,
  order: 4,
  children: [
    {
      id: 'registers-overview',
      title: 'Pregled blagajna',
      icon: 'mdi-eye',
      show: true,
      order: 1,
      content: () => `
      <h2>Pregled blagajna</h2>
      <p>
        Stranica s pregledom blagajna prikazuje sve blagajne vezane za
        trenutno odabrano prodajno mjesto.
      </p>

      <h3 class="mt-4">Status blagajne</h3>
      <table class="info-table">
        <thead>
          <tr>
            <th>Status</th>
            <th>Opis</th>
            <th>Akcija</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><span class="status-chip success" style="color: white;">OK</span></td>
            <td>Blagajna je aktivna i dostupna</td>
            <td>Možete otvoriti blagajnu</td>
          </tr>
          <tr>
            <td><span class="status-chip warning" style="color: white;">PROCESSING</span></td>
            <td>Blagajna je u obradi</td>
            <td>Pričekajte da se obrada završi</td>
          </tr>
          <tr>
            <td><span class="status-chip error" style="color: white;">RESERVED</span></td>
            <td>Blagajna je zauzeta</td>
            <td>Blagajnu koristi drugi korisnik</td>
          </tr>
        </tbody>
      </table>

      <h3 class="mt-4">Kako otvoriti blagajnu?</h3>
      <ol>
        <li>Na listi blagajna pronađite željenu blagajnu</li>
        <li>Provjerite da je status "OK" (zelena boja)</li>
        <li>Kliknite na karticu blagajne</li>
        <li>Sustav će vas automatski preusmjeriti na blagajnu</li>
      </ol>
    `
    },
    {
      id: 'registers-add',
      title: 'Dodavanje blagajne',
      icon: 'mdi-plus',
      show: true,
      order: 2,
      content: () => `
      <h2>Dodavanje blagajne</h2>
      <p>
        Prije nego što možete početi raditi na blagajni, potrebno je
        kreirati novu blagajnu u sustavu.
      </p>

      <h3 class="mt-4">Preduvjeti</h3>
      <ul>
        <li>Morate imati kreiranu firmu</li>
        <li>Morate imati kreirano prodajno mjesto</li>
        <li>Morate imati administratorske privilegije</li>
      </ul>

      <h3 class="mt-4">Korak po korak</h3>
      <ol>
        <li>Idite na stranicu "Blagajne"</li>
        <li>Kliknite gumb "+ Dodaj blagajnu" u gornjem desnom kutu</li>
        <li>Ispunite obavezna polja:
          <ul>
            <li><strong>Naziv:</strong> Npr. "Blagajna 1" ili "Šalter 1"</li>
            <li><strong>Broj blagajne:</strong> Jedinstveni broj blagajne (npr. 1, 2, 3...). Broj blagajne je broj koji je dio računa.</li>
          </ul>
        </li>
        <li>Odaberite tip prijave:
          <ul>
            <li><strong>Prijava korisnikom (klasično):</strong> Automatska prijava bez odabira</li>
            <li><strong>Prijava odabirom korisnika:</strong> Odabir korisnika prilikom otvaranja</li>
            <li><strong>Prijava unosom PINA korisnika:</strong> Prijava pomoću PIN koda</li>
          </ul>
        </li>
        <li>Kliknite "Spremi"</li>
      </ol>

      <div class="success-box mt-4">
        <i class="mdi mdi-check-circle" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
        <strong>Savjet:</strong> Preporučujemo koristiti "Prijava odabirom korisnika" ili "Prijava unosom PINA korisnika"
        ako više korisnika dijeli istu blagajnu.
      </div>
    `
    },
    {
      id: 'registers-settings',
      title: 'Postavke blagajne',
      icon: 'mdi-cog',
      show: true,
      order: 3,
      content: () => `
      <h2 id="settings">Postavke blagajne</h2>
      <p>
        Svaka blagajna može imati vlastite postavke koje određuju način rada,
        izgled računa i povezanost s uređajima.
      </p>

      <h3 class="mt-4">Pristup postavkama</h3>
      <ol>
        <li>Idite na <strong>"Blagajne" → "Pregled blagajna"</strong></li>
        <li>Pronađite blagajnu u listi</li>
        <li>Kliknite <i class="mdi mdi-cog"></i> <strong>"Postavke"</strong></li>
      </ol>

      <h3 class="mt-4">Tipovi prijave</h3>
      <p>Odaberite način prijave korisnika na blagajnu:</p>
      <table class="info-table">
        <thead>
          <tr>
            <th>Tip</th>
            <th>Opis</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>PIN</strong></td>
            <td>Korisnik se prijavljuje sa 4-znamenkastim PIN-om</td>
          </tr>
          <tr>
            <td><strong>Username/Password</strong></td>
            <td>Standardna prijava sa email i lozinkom</td>
          </tr>
          <tr>
            <td><strong>Kartica</strong></td>
            <td>Prijava skeniranjem NFC/RFID kartice</td>
          </tr>
        </tbody>
      </table>

      <h3 class="mt-4">Postavke računa</h3>
      <ul>
        <li><strong>Automatski ispis</strong> - Račun se automatski ispisuje nakon fiskalizacije</li>
        <li><strong>Broj kopija</strong> - Koliko primjeraka računa se ispisuje (1-3)</li>
        <li><strong>Prikaz logoa</strong> - Prikazuje logo firme na računu</li>
        <li><strong>Napomena na računu</strong> - Prilagođena poruka na dnu računa</li>
      </ul>

      <h3 class="mt-4">Povezivanje pisača</h3>
      <ol>
        <li>U sekciji <strong>"Pisači"</strong> kliknite <strong>"Dodaj pisač"</strong></li>
        <li>Odaberite pisač iz liste dostupnih pisača</li>
        <li>Odaberite tip ispisa: Fiskalni račun, Kopija, Kuhinjski ispis</li>
        <li>Kliknite <strong>"Spremi"</strong></li>
      </ol>

      <div class="info-box">
        <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
        <div>
          <strong>Napomena:</strong> Pisači moraju biti prethodno dodani u <strong>"Postavke" → "Pisači i integracije"</strong>.
        </div>
      </div>

      <h3 class="mt-4">POS terminal</h3>
      <p>Ako koristite POS terminal za kartično plaćanje:</p>
      <ul>
        <li>Odaberite POS terminal iz liste</li>
        <li>Konfiguracija se vrši u <strong>"Postavke" → "Pisači i integracije" → "POS uređaji"</strong></li>
      </ul>

      <h3 class="mt-4">Ostale postavke</h3>
      <ul>
        <li><strong>Zadani operator</strong> - Zadani korisnik za blagajnu</li>
        <li><strong>Automatsko zatvaranje smjene</strong> - Smjena se automatski zatvara nakon X sati</li>
        <li><strong>Obvezna količina</strong> - Korisnik mora unijeti količinu za svaki artikl</li>
      </ul>

      <div class="warning-box">
        <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
        <div>
          <strong>Važno:</strong> Nakon promjene postavki, restartujte aplikaciju na blagajni da bi promjene stupile na snagu.
        </div>
      </div>
    `
    },
    {
      id: 'registers-status',
      title: 'Status blagajne',
      icon: 'mdi-information',
      show: true,
      order: 4,
      content: () => `
      <h2 id="register-status">Status blagajne</h2>
      <p>
        Svaka blagajna u sustavu može imati različite statuse koji označavaju trenutno stanje
        i dostupnost blagajne za rad. Status blagajne je važan za upravljanje radom
        i osiguranje da više korisnika ne koristi istu blagajnu istovremeno.
      </p>

      <h3 class="mt-4">Tipovi statusa</h3>

      <table class="info-table">
        <thead>
          <tr>
            <th>Status</th>
            <th>Oznaka</th>
            <th>Opis</th>
            <th>Akcije dostupne</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><span class="status-chip success" style="color: white;">OK</span></td>
            <td><i class="mdi mdi-check-circle" style="color: #4CAF50; font-size: 20px;"></i></td>
            <td>Blagajna je slobodna i dostupna za rad</td>
            <td>Otvaranje smjene, Prijava</td>
          </tr>
          <tr>
            <td><span class="status-chip warning" style="color: white;">PROCESSING</span></td>
            <td><i class="mdi mdi-clock-outline" style="color: #FF9800; font-size: 20px;"></i></td>
            <td>Blagajna je u upotrebi, smjena je otvorena</td>
            <td>Izdavanje računa, Zatvaranje smjene</td>
          </tr>
          <tr>
            <td><span class="status-chip error" style="color: white;">RESERVED</span></td>
            <td><i class="mdi mdi-lock" style="color: #F44336; font-size: 20px;"></i></td>
            <td>Blagajna je rezervirana ili zaključana</td>
            <td>Samo administratorsko otključavanje</td>
          </tr>
          <tr>
            <td><span class="status-chip grey" style="color: white;">OFFLINE</span></td>
            <td><i class="mdi mdi-wifi-off" style="color: #9E9E9E; font-size: 20px;"></i></td>
            <td>Blagajna nije povezana na mrežu</td>
            <td>Nema dostupnih akcija</td>
          </tr>
          <tr>
            <td><span class="status-chip error" style="color: white;">ERROR</span></td>
            <td><i class="mdi mdi-alert-circle" style="color: #F44336; font-size: 20px;"></i></td>
            <td>Greška u radu blagajne ili fiskalnog uređaja</td>
            <td>Potrebno tehničko rješavanje</td>
          </tr>
        </tbody>
      </table>

      <h3 class="mt-4">Prijelazi između statusa</h3>

      <div class="info-box">
        <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
        <div>
          <strong>Životni ciklus statusa:</strong><br><br>
          <strong>OK</strong> (slobodna)<br>
          ↓ <em>Korisnik otvara smjenu</em><br>
          <strong>PROCESSING</strong> (u radu)<br>
          ↓ <em>Korisnik zatvara smjenu</em><br>
          <strong>OK</strong> (slobodna)<br>
        </div>
      </div>

      <h3 class="mt-4">Detaljni opis statusa</h3>

      <h4 class="mt-3">1. Status: OK</h4>
      <p>
        Blagajna je potpuno slobodna i spremna za rad. Nijedan korisnik trenutno ne radi na njoj.
      </p>
      <ul>
        <li>Nijedna smjena nije otvorena</li>
        <li>Korisnici mogu prijaviti blagajnu i otvoriti novu smjenu</li>
        <li>Idealno stanje za početak rada</li>
      </ul>

      <h4 class="mt-3">2. Status: PROCESSING</h4>
      <p>
        Blagajna je aktivna i korisnik je otvorio smjenu. U ovom statusu se mogu izdavati računi
        i obavljati sve transakcije.
      </p>
      <ul>
        <li>Smjena je otvorena</li>
        <li>Prikazan je korisnik koji trenutno radi na blagajni</li>
        <li>Prikazano je vrijeme otvaranja smjene</li>
        <li>Dostupne su sve blagajničke funkcije</li>
      </ul>

      <div class="warning-box">
        <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
        <div>
          <strong>Napomena:</strong> Dok je blagajna u statusu PROCESSING,
          drugi korisnici ne mogu otvoriti smjenu na istoj blagajni.
        </div>
      </div>

      <h4 class="mt-3">3. Status: RESERVED</h4>
      <p>
        Blagajna je rezervirana ili zaključana, obično iz administrativnih razloga:
      </p>
      <ul>
        <li>Blagajna je privremeno onemogućena</li>
        <li>Potrebno je tehničko održavanje</li>
        <li>Administrativno blokirana zbog nedosljednosti</li>
        <li>Samo administrator može otključati blagajnu</li>
      </ul>

      <h4 class="mt-3">4. Status: OFFLINE</h4>
      <p>
        Blagajna nije povezana na sustav ili server:
      </p>
      <ul>
        <li>Nema mrežne veze</li>
        <li>Blagajna je isključena</li>
        <li>Problem sa komunikacijom</li>
      </ul>

      <h4 class="mt-3">5. Status: ERROR</h4>
      <p>
        Postoji greška u radu blagajne ili povezanog uređaja:
      </p>
      <ul>
        <li>Greška fiskalnog uređaja</li>
        <li>Problem sa pisačem</li>
        <li>Tehnički problem koji zahtijeva intervenciju</li>
      </ul>

      <h3 class="mt-4">Provjera statusa blagajne</h3>

      <h4 class="mt-3">Način 1: Lista blagajna</h4>
      <ol>
        <li>Idite na <strong>"Blagajne" → "Pregled blagajna"</strong></li>
        <li>Status je prikazan kraj svake blagajne s obojenom oznakom</li>
        <li>Možete filtrirati po statusu (npr. prikaži samo slobodne blagajne)</li>
      </ol>

      <h4 class="mt-3">Način 2: Dashboard</h4>
      <ol>
        <li>Na početnoj stranici (Dashboard)</li>
        <li>Widget "Status blagajna" prikazuje sve blagajne s trenutnim statusima</li>
        <li>Brzo pregledno stanje svih blagajna</li>
      </ol>

      <h3 class="mt-4">Rješavanje problema sa statusom</h3>

      <table class="info-table">
        <thead>
          <tr>
            <th>Problem</th>
            <th>Rješenje</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Blagajna je zaglavljenja u statusu PROCESSING</td>
            <td>Administrator može prisilno zatvoriti smjenu iz admin panela</td>
          </tr>
          <tr>
            <td>Blagajna pokazuje OFFLINE</td>
            <td>Provjerite mrežnu vezu i pokrenite blagajnu ponovo</td>
          </tr>
          <tr>
            <td>Status ERROR</td>
            <td>Provjerite fiskalni uređaj, pisač i log datoteke za detalje greške</td>
          </tr>
          <tr>
            <td>Blagajna je RESERVED bez razloga</td>
            <td>Kontaktirajte administratora za otključavanje</td>
          </tr>
        </tbody>
      </table>

      <div class="success-box">
        <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
        <div>
          <strong>Savjet:</strong> Redovito pratite status blagajna na Dashboard-u.
          Ako blagajna dugo ostane u statusu PROCESSING bez aktivnosti, to može ukazati na problem.
        </div>
      </div>

      <h3 class="mt-4">Često postavljana pitanja</h3>

      <h4 class="mt-3">Što ako zaboravim zatvoriti smjenu?</h4>
      <p>
        Blagajna će ostati u statusu PROCESSING sve dok ne zatvorite smjenu.
        Administrator može prisilno zatvoriti smjenu ako je potrebno.
      </p>

      <h4 class="mt-3">Može li više korisnika raditi na jednoj blagajni istovremeno?</h4>
      <p>
        Ne. Blagajna može imati samo jednu otvorenu smjenu u isto vrijeme.
        Dok je smjena otvorena (status PROCESSING), drugi korisnici ne mogu otvoriti smjenu.
      </p>

      <h4 class="mt-3">Koliko dugo može smjena biti otvorena?</h4>
      <p>
        Smjena može biti otvorena neograničeno vrijeme, ali preporučuje se zatvaranje
        smjene na kraju radnog dana ili smjene radi točnih izvještaja i evidencije.
      </p>
    `
    }
  ]
}
